import {
  Component,
  OnInit,
  Inject,
  PLATFORM_ID,
  OnDestroy,
  DOCUMENT,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-happy-helper-banner',
  standalone: true,
  imports: [MatIconModule, TranslateModule],
  templateUrl: './happy-helper-banner.component.html',
  styleUrls: ['./happy-helper-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { ngSkipHydration: 'true' },
})
export class HappyHelperBannerComponent implements OnInit, OnDestroy {
  protected readonly isBannerVisible = signal(false);
  readonly happyHelperCode: string = 'handyhand2025';
  protected readonly codeCopiedMessageVisible = signal(false);
  private readonly bannerClosedStorageKey = 'cleaningBannerClosed';
  private destroy$ = new Subject<void>();
  private timeoutIds: ReturnType<typeof setTimeout>[] = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const timeoutId = setTimeout(() => {
        this.isBannerVisible.set(true);
        setTimeout(() => {
          const banner = document.querySelector('.cleaning-banner');
          if (banner) {
            banner.classList.add('visible');
          }
        }, 50);
      }, 3000);
      this.timeoutIds.push(timeoutId);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.timeoutIds.forEach((id) => clearTimeout(id));
    this.timeoutIds = [];
  }

  closeBanner(): void {
    this.isBannerVisible.set(false);
    if (
      isPlatformBrowser(this.platformId) &&
      typeof sessionStorage !== 'undefined'
    ) {
      sessionStorage.setItem(this.bannerClosedStorageKey, 'true');
    }
  }

  copyCodeAndRedirect(): void {
    if (isPlatformBrowser(this.platformId)) {
      navigator.clipboard
        .writeText(this.happyHelperCode)
        .then(() => {
          this.codeCopiedMessageVisible.set(true);

          const timeoutId1 = setTimeout(() => {
            this.codeCopiedMessageVisible.set(false);
          }, 3000);
          this.timeoutIds.push(timeoutId1);

          const timeoutId2 = setTimeout(() => {
            this.goToUserHappyHelper();
          }, 1500);
          this.timeoutIds.push(timeoutId2);
        })
        .catch(() => {
          // Optional: Add user feedback for copy failure
        });
    }
  }

  goToUserHappyHelper(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.open(
        'https://happyhelper.dk?utm_medium=website_landingpage&utm_source=handyhand&utm_campaign=happy_handy_colab',
        '_blank',
      );
    }
  }
}
